import React, { Component } from 'react';
import { Form, Button, Row, Col, Select, DatePicker, Table } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/collector';
import moment from 'moment';

class CollectorHistory extends Component {
    state = {
        startDate: null,
        endDate: null,
    }
    onFinish = async (values) => {
        this.props.onLoad({
            employeeId: values.employee,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        }, this.props.token);
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    dateHandler = (value, dateString) => {
        this.setState(prevState => {
            return {
                ...prevState,
                startDate: dateString[0],
                endDate: dateString[1]
            }
        });
    }
    render() {
        let { RangePicker } = DatePicker;
        let select = null;
        const { Option } = Select;
        let option = null;
        let collector = [];
        let table = null;
        const dataSource = [];

        if (this.props.history) {
            this.props.history.collectorTransactionInfos.map(t => {
                let date = moment(t.transactionTime);
                date.locale('my');
                let data = {
                    ...t,
                    key: t.id,
                    amount: `${t.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    openingBalance: `${t.openingBalance}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    closingBalance: `${t.closingBalance}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    transactionTime: date.format('lll')
                };
                dataSource.push(data);
                return;
            });
        }

        const columns = [
            {
                title: 'Time',
                dataIndex: 'transactionTime',
                key: 'transactionTime',
                align:'center',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                align: 'center',
            },
            {
                title: 'OpeningBalance',
                dataIndex: 'openingBalance',
                key: 'openingBalance',
                align: 'right',
            },
            {
                title: 'Amount',
                dataIndex: 'amount',
                key: 'amount',
                align: 'right',
            },
            {
                title: 'ClosingBalance',
                dataIndex: 'closingBalance',
                key: 'closingBalance',
                align: 'right',
            },

        ];

        if (dataSource.length > 0) {
            table = <Table dataSource={dataSource} columns={columns} />
        }

        const employees = this.props.employees;
        if (employees) {
            employees.filter(employee => employee.roles[0].id === 3).map(c => {
                collector.push(c);
            });
        }
        if (collector.length > 0) {
            option = collector.map(c => {
                return <Option key={c.id} value={c.id}>{c.name}</Option>
            });
        }
        if (option) {
            select = (<Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {option}
            </Select>);
        }
        return (
            <>
                <div style={{ fontSize: '24px', paddingLeft: '50px' }}>Transfer History</div>
                <br />
                <Row justify="left" align="middle" style={{ paddingLeft: '60px' }}>
                    <Col lg={20} sm={20}>
                        <Form
                            name="basic"
                            layout="inline"
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Form.Item
                                style={{ width: '200px' }}
                                label="Employee"
                                name="employee"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select employee',
                                    },
                                ]}
                            >
                                {select}
                            </Form.Item>
                            <Form.Item
                                name="dates"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select dates',
                                    },
                                ]}
                            >
                                <RangePicker onChange={this.dateHandler} format="DD-MM-YYYY" />
                            </Form.Item>
                            <Form.Item >
                                <Button type="primary" htmlType="submit">
                                    Load
                            </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <br />
                <br />
                {table}
            </>
        )
    }

};
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        message: state.collector.message,
        error: state.collector.error,
        employees: state.employee.employees,
        history: state.collector.history,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onLoad: (request, token) => dispatch(actions.collectorHistory(request, token))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CollectorHistory);